var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
var activate_form = document.querySelector('.activate-form');
if(login_form &&  recover_form){
  document.querySelectorAll('.enable-login').forEach(function(backToLogin) {
    backToLogin.addEventListener('click',function(e){
      e.preventDefault();
      login_form.classList.remove('hide-form');
      recover_form.classList.add('hide-form');
      activate_form.classList.add('hide-form');
    });
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
  document.querySelector('.activate-acc').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    activate_form.classList.remove('hide-form');
  });
}
document.querySelectorAll('.edit-address-button').forEach(function(button) {
  button.addEventListener('click', function() {
    var id = this.getAttribute('data-addressid');
    var parent = this.closest('.singal-add');
    var formId = parent.querySelector('.address-edit-form').getAttribute('data-id');
    var allFormIds = parent.querySelectorAll('.address-edit-form').forEach(function(form) {
      var formId = form.getAttribute('data-id');
      if (id === formId) {
        form.classList.toggle('active-form');
      } else {
        form.classList.remove('active-form');
      }
    });
    document.querySelectorAll('.customer-field').forEach(function(element) {
        var label = element.querySelector('label');
        var input = element.querySelector('input');
        if (label && input) {
          var width = label.offsetWidth + 24;
          input.style.paddingLeft = width + 'px';
        }
      }); 
      document.querySelectorAll('.customer-field input').forEach(function(input) {
        input.addEventListener('click', function() {
            var label = this.nextElementSibling;
            var width = label.offsetWidth + 24;
            this.style.paddingLeft = width + 'px';
        });
      });
  });
});

// document.querySelectorAll('.edit-address-button').forEach(function(button) {
//   button.addEventListener('click', function() {
//     var siblings = this.parentNode.parentNode.parentNode.querySelectorAll('.singal-add');
//     siblings.forEach(function(sibling) {
//       var editForm = sibling.querySelector('.address-edit-form');
//       if (editForm.classList.contains('active-form')) {
//         editForm.classList.remove('active-form');
//       }
//     });
//   });
// });

// document.querySelectorAll('.edit-address-button').forEach(function(button) {
//   button.addEventListener('click', function() {
//     var id = this.getAttribute('data-addressid');
//     var parent = this.closest('.singal-add');
//     var formId = parent.querySelector('.address-edit-form').getAttribute('data-id');
//     parent.parentElement.querySelectorAll('.singal-add').forEach(function(sibling) {
//       if (sibling !== parent) {
//         if(sibling.querySelector('.address-edit-form') != null){
//           sibling.querySelector('.address-edit-form').classList.remove('active');
//         }
//       }
//     });
//     var form = parent.querySelector('.address-edit-form');
//     if (id === formId) {
//       form.classList.toggle('active');
//     } else {
//       form.classList.remove('active');
//     }
//   });
// });
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
  destroyButton.addEventListener('click',function(e){
    var destroyId = this.dataset.destroy;
    console.log(destroyId);
    Shopify.postLink(
      '/account/addresses/'+destroyId, 
      {'parameters': {'_method': 'delete'}}
    );
  });
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}
if(document.querySelector('.add-address')){
  document.querySelector('.add-address').addEventListener('click',function(e){
    document.getElementById('address_form_new').classList.toggle('active-open-form');
    document.getElementsByClassName('main-add')[0].classList.add('d-none');
    document.getElementsByClassName('new-add-btn')[0].classList.add('d-none');

      document.querySelectorAll('.customer-field').forEach(function(element) {
        var label = element.querySelector('label');
        var input = element.querySelector('input');
        if (label && input) {
          var width = label.offsetWidth + 24;
          input.style.paddingLeft = width + 'px';
        }
      }); 
      document.querySelectorAll('.customer-field input').forEach(function(input) {
        input.addEventListener('click', function() {
            var label = this.nextElementSibling;
            var width = label.offsetWidth + 24;
            this.style.paddingLeft = width + 'px';
        });
      });
    
  });
}
document.querySelectorAll('.show-pass').forEach(function(element) {
  element.addEventListener('click', function() {
    var passwordInput = this.parentElement.querySelector('.customer-field input');
    if (passwordInput.type === "password") {
        passwordInput.type = "text";
    } else {
        passwordInput.type = "password";
    }
  });
});
// $('.singal-add .def-uncheck').click(function() {
//   var id = $(this).attr('data-id-id')
//   $(this).parents('.singal-add').find(".address-form .address-edit-form" ).each(function() {
//     var nId = $(this).attr('data-id')
//     if (nId == id) {
//       $(this).find('input[type="checkbox"]').prop('checked','true');
//       $(this).find('form').trigger('submit');
//     }
//   });
// })
document.querySelectorAll('.singal-add .def-uncheck').forEach(function(element) {
  element.addEventListener('click', function() {
    var id = this.getAttribute('data-id-id');
    var addressForms = this.closest('.singal-add').querySelectorAll('.address-form .address-edit-form');
    addressForms.forEach(function(addressForm) {
      var nId = addressForm.getAttribute('data-id');
      if (nId === id) {
        var checkboxes = addressForm.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(function(checkbox) {
          checkbox.checked = true;
        });
        var form = addressForm.querySelector('form');
        if (form) {
          form.submit();
        } else {
          console.error('Form not found within the address edit form.');
        }
      }
    });
  });
});
document.querySelectorAll('.customer-field').forEach(function(element) {
  var label = element.querySelector('label');
  var input = element.querySelector('input');
  if (label && input) {
    var width = label.offsetWidth + 24;
    input.style.paddingLeft = width + 'px';
  }
}); 
document.querySelectorAll('.customer-field input').forEach(function(input) {
  input.addEventListener('click', function() {
      var label = this.nextElementSibling;
      var width = label.offsetWidth + 24;
      this.style.paddingLeft = width + 'px';
  });
});